@switch (type$$()) {
    @case (NotificationTypeEnum.TOAST) {
        <toast></toast>
    }

    @case (NotificationTypeEnum.BANNER) {
        <banner></banner>
    }
}
